import {
  getProjectProductionSteps,
  createProjectProductionStep,
  updateProjectProductionStep,
  deleteProjectProductionStep
} from '@/api/workflow';

export default {
  namespaced: true,
  state: () => ({
    steps: {
      loading: false,
      error: null,
      items: [],
      projectId: null
    }
  }),
  mutations: {
    fetchProductionStepsPending(state) {
      state.steps.loading = true;
      state.steps.error = null;
      state.steps.items = [];
      state.steps.projectId = null;
    },
    fetchProductionStepsSuccess(state, { steps, projectId }) {
      state.steps.loading = false;
      state.steps.error = null;
      state.steps.items = steps;
      state.steps.projectId = projectId;
    },
    fetchProductionStepsFailure(state, error) {
      state.steps.loading = false;
      state.steps.error = error;
    },
    setProductionStepsError(state, error) {
      state.steps.error = error;
    },
    addProductionStep(state, step) {
      state.steps.items = [...state.steps.items, step];
    },
    setProductionStep(state, step) {
      state.steps.items = state.steps.items.map(item => {
        return item.id === step.id ? step : item;
      });
    },
    removeProductionStep(state, step) {
      state.steps.items = state.steps.items.filter(item => item.id !== step.id);
    }
  },
  actions: {
    async fetchCurrentProjectProductionSteps({ commit, state, rootState }) {
      if (state.steps.projectId === rootState.workflow.currentProjectId) {
        return;
      }
      commit('fetchProductionStepsPending');
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId
        };
        const steps = await getProjectProductionSteps(payload);
        commit('fetchProductionStepsSuccess', { steps, projectId: payload.projectId });
      } catch (err) {
        console.error('Server error when getting production steps', err);
        commit('fetchProductionStepsFailure', 'Error when getting production steps');
      }
    },
    async addCurrentProjectProductionStep({ commit, rootState }, { step }) {
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          ...step,
          userIds: step.users.map(u => u.id)
        };
        const result = await createProjectProductionStep(payload);
        commit('addProductionStep', result);
      } catch (err) {
        console.error(`Server error when adding production step`, err);
        throw err;
      }
    },
    async updateCurrentProjectProductionStep({ commit, state, rootState }, { step }) {
      const previousValue = state.steps.items.find(a => a.id === step.id);
      commit('setProductionStep', step);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          stepId: step.id,
          ...step,
          userIds: step.users.map(u => u.id)
        };
        await updateProjectProductionStep(payload);
      } catch (err) {
        console.error(`Server error when updating production step`, err);
        commit('setProductionStep', previousValue);
        commit('setProductionStepsError', 'Error when updating production step');
      }
    },
    async updateCurrentProjectProductionStepUsers({ commit, state, rootState }, { step }) {
      const previousValue = state.steps.items.find(item => item.id === step.id);
      commit('setProductionStep', step);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          stepId: step.id,
          userIds: step.users.map(u => u.id)
        };
        await updateProjectProductionStep(payload);
      } catch (err) {
        console.error(`Server error when updating production step users`, err);
        commit('setProductionStep', previousValue);
        commit('setProductionStepsError', 'Error when updating production step');
      }
    },
    async removeCurrentProjectProductionStep({ commit, rootState }, { step }) {
      commit('removeProductionStep', step);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          stepId: step.id
        };
        await deleteProjectProductionStep(payload);
      } catch (err) {
        console.error(`Server error when removing production step`, err);
        commit('setProductionStepsError', 'Error when removing production step');
      }
    }
  }
};
